import { AuthService } from "@core/services";

export const appInitializer = (authService: AuthService) => () => authService.refreshToken();